import * as React from "react";
import { MediaQuery } from "react-responsive";
import { Accordion } from "../accordion/accordion/accordion.mjs";
import { AccordionContent } from "../accordion/accordion-content/accordion-content.mjs";
import { AccordionHeader } from "../accordion/accordion-header/accordion-header.mjs";
import { AccordionItem } from "../accordion/accordion-item/accordion-item.mjs";
import { AccordionItemContext } from "../accordion/accordion-item/accordion-item-context.mjs";
import { AccordionTitle } from "../accordion/accordion-title/accordion-title.mjs";
import { Badge } from "../badge/badge.mjs";
import { Grid } from "../grid/grid/grid.mjs";
import { GridColumn } from "../grid/grid-column/grid-column.mjs";
import { PropsChecker } from "../helpers/props-checker/props-checker.mjs";
import { Tabs } from "../tabs/tabs/tabs.mjs";
import { TabsItem } from "../tabs/tabs-item/tabs-item.mjs";
import { ThemeContext } from "../helpers/theme-provider/theme-provider.mjs";
const TabCordion = (props) => {
  return /* @__PURE__ */ React.createElement(PropsChecker, { componentProps: props, componentName: "TabCordion", defaultValueName: "defaultCurrentTab", valueName: "currentTab", onChangeNames: "onTabChange" }, /* @__PURE__ */ React.createElement(TabCordionInner, { ...props }));
};
const _TabCordionInner = class _TabCordionInner extends React.Component {
  constructor(props) {
    super(props);
    this.onTabChange = (prevTab, nextTab) => {
      if (!this.isCurrentTabControlled()) {
        this.setState({
          currentTab: [nextTab]
        });
      }
      if (this.props.onTabChange) {
        this.props.onTabChange([prevTab], [nextTab]);
      }
    };
    this.onAccordionChange = (nextOpen) => {
      if (!this.isCurrentTabControlled()) {
        this.setState({
          currentTab: nextOpen
        });
      }
      if (this.props.onTabChange) {
        this.props.onTabChange(this.openItems, nextOpen);
      }
    };
    this.renderAccordionItem = (props2) => {
      const getType = (isOpen) => {
        if (props2.type === "employee") {
          return isOpen ? "employee-active" : "employee";
        }
        return isOpen ? "primary" : "inactive";
      };
      return /* @__PURE__ */ React.createElement(AccordionItem, { className: props2.className, type: props2.type === "employee" ? "employee" : void 0, icon: props2.icon, id: props2.id, key: props2.id }, /* @__PURE__ */ React.createElement(AccordionHeader, null, props2.tagContent ? /* @__PURE__ */ React.createElement(AccordionItemContext.Consumer, null, (context) => /* @__PURE__ */ React.createElement(AccordionTitle, { className: "h4" }, /* @__PURE__ */ React.createElement(Grid, { gutter: "xsmall", align: ["middle-xs"], element: "span" }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["min"] }, props2.label), /* @__PURE__ */ React.createElement(GridColumn, { width: ["min"] }, props2.tagContent && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, "("), /* @__PURE__ */ React.createElement(Badge, { size: "medium", text: props2.tagContent, purpose: getType(context.isOpen) }), /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, ")")))))) : /* @__PURE__ */ React.createElement(AccordionTitle, { className: "h4" }, props2.label)), /* @__PURE__ */ React.createElement(AccordionContent, null, props2.children));
    };
    this.state = {
      currentTab: Array.isArray(props.defaultCurrentTab) ? props.defaultCurrentTab : [props.defaultCurrentTab],
      isMounted: false
    };
  }
  componentDidMount() {
    const { media } = this.context;
    const { breakPoint } = this.props;
    this.setState({
      isMounted: true
    });
    if (!window.matchMedia("(min-width: ".concat(media.width[breakPoint].min, ")")).matches) {
      if (!this.isCurrentTabControlled()) {
        this.setState({
          currentTab: null
        });
      }
      if (this.props.onTabChange) {
        this.props.onTabChange(this.openItems, []);
      }
    }
  }
  get currentTab() {
    var _a, _b, _c, _d;
    let getDefaultCurrentTab = Array.isArray(this.props.defaultCurrentTab) ? this.props.defaultCurrentTab[this.props.defaultCurrentTab.length - 1] : this.props.defaultCurrentTab;
    return this.isCurrentTabControlled(this.props.currentTab) ? (_b = (_a = this.props.currentTab) == null ? void 0 : _a[this.props.currentTab.length - 1]) != null ? _b : getDefaultCurrentTab : (_d = (_c = this.state.currentTab) == null ? void 0 : _c[this.state.currentTab.length - 1]) != null ? _d : getDefaultCurrentTab;
  }
  get openItems() {
    var _a;
    if (this.isCurrentTabControlled(this.props.currentTab)) {
      return this.props.currentTab;
    }
    return (_a = this.state.currentTab) != null ? _a : [];
  }
  isCurrentTabControlled(currentTab = this.props.currentTab) {
    return !!this.props.onTabChange && Array.isArray(currentTab);
  }
  BEM() {
    const classArray = ["tab-cordion"];
    if (this.props.background) {
      classArray.push("tab-cordion--background-" + this.props.background);
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  mapChildren(isAccordion = false) {
    return React.Children.toArray(this.props.children).filter((child) => {
      return React.isValidElement(child) && child.type === TabsItem;
    }).map((child) => {
      if (isAccordion) {
        const props = {
          ...child.props,
          className: "tab-cordion__item"
        };
        return this.renderAccordionItem(props);
      } else {
        return React.cloneElement(child, {
          icon: !this.props.hideIconsOnTabs ? child.props.icon : void 0
        });
      }
    });
  }
  renderAccordion() {
    return /* @__PURE__ */ React.createElement(
      Accordion,
      {
        theme: this.props.theme,
        fullWidth: this.props.fullWidth,
        openItem: this.openItems,
        onToggle: this.onAccordionChange,
        className: this.BEM(),
        bordered: false,
        headingLevel: this.props.headingLevel ? this.props.headingLevel : 2
      },
      this.mapChildren(true)
    );
  }
  renderTabs() {
    const { currentTab, defaultCurrentTab, onTabChange, breakPoint, hideIconsOnTabs, headingLevel, ...rest } = this.props;
    return /* @__PURE__ */ React.createElement(Tabs, { ...rest, currentTab: this.currentTab, onTabChange: this.onTabChange, headingLevel: headingLevel != null ? headingLevel : 2, theme: this.props.theme }, this.mapChildren());
  }
  renderTabCordion() {
    const { media } = this.context;
    const { breakPoint } = this.props;
    return /* @__PURE__ */ React.createElement(MediaQuery, { minWidth: media.width[breakPoint].min }, (matches) => matches ? this.renderTabs() : this.renderAccordion());
  }
  render() {
    return this.state.isMounted ? this.renderTabCordion() : this.renderTabs();
  }
};
_TabCordionInner.contextType = ThemeContext;
_TabCordionInner.defaultProps = {
  breakPoint: "sm"
};
let TabCordionInner = _TabCordionInner;
export {
  TabCordion,
  TabCordionInner
};
